import { listReport } from './WashingCountByDay/WashingCount.i18n.ja'

export const washingCount = {
  listReport,
}
